import { Component, Inject, OnInit } from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-datos-compra',
  templateUrl: './datos-compra.component.html',
  styleUrls: ['./datos-compra.component.scss']
})
export class DatosCompraComponent implements OnInit {
  form!: FormGroup;
  private dataSource: any;
  constructor(
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data
  ) {
    console.log("data ", data)
    this.dataSource = this.data;
  }

  ngOnInit(): void {
  }

  construirFormGroup() {
    return  this.fb.group({
      nombre: [this.dataSource['nombre'] ?? '' , Validators.required],
      apellido: [this.dataSource['apellido'] ?? '', Validators.required],
      celular_nro: [this.dataSource['celular_nro'] ?? '', Validators.required],
      documento_nro: [this.dataSource['documento_nro'], Validators.required],
      email: [this.dataSource['email'], Validators.required],
    });
  }


}
